import api from "./api";
import { warehouseType } from "../components/Warehouse/WarehouseType";
export type DeleteWarehouseDto = {
  id: number | string;
};

export const getWarehouses = async () => {
  return await api.get("/warehouses");
};

/*delete Warehouse */

export const deleteWarehouses = async (dto: DeleteWarehouseDto) => {
  return await api.delete(`/warehouses/${dto.id}`);
};

/* Warehouse By id*/

export const getWarehousesById = async (warehousesId: string | undefined) => {
  return await api.get(`/warehouses/${warehousesId}`);
};

/*create Warehouse */

export const createWarehouse = async (warehouseDetails: warehouseType) => {
  return await api.post("/warehouses", warehouseDetails);
};

/*edit Warehouse */

export const editWarehouse = async (warehousesId: any, body: warehouseType) => {
  return await api.put(`/warehouses/${warehousesId}`, body);
};

/*Search & Filter */

export const getWarehousesApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/warehouses?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};

/*select Warehouse */

export const getWarehousesDropdown = async () => {
  return await api.get("/warehouses/dropdown");
};